export function StepIndicator({ steps, currentStep, onStepClick }) {
  return (
    <div className="flex flex-col items-center gap-8">
      <div className="flex items-center justify-between w-full">
        {steps.map((step, index) => (
          // <div key={step.id} className="flex items-center flex-1">
          <div key={step.id} className="flex items-center" style={{ flex: index < steps.length - 1 ? 1 : undefined }}>
            <div className="flex flex-col items-center">
              <button
                onClick={() => onStepClick(step.id)}
                className={`flex items-center justify-center w-12 h-12 rounded-full font-semibold text-sm transition-all ${
                  currentStep === step.id
                    ? "bg-primary text-primary-foreground shadow-lg scale-110"
                    : currentStep > step.id
                      ? "bg-green-600 text-white"
                      : "bg-muted text-muted-foreground hover:bg-muted/80"
                }`}
                disabled={currentStep < step.id}
              >
                {currentStep > step.id ? (
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  <step.icon className="w-5 h-5" />
                )}
              </button>
              <span className="text-xs font-medium text-muted-foreground mt-2 text-center max-w-[80px]">
                {step.label}
              </span>
            </div>

            {index < steps.length - 1 && (
              <div
                className={`flex-1 h-1 mx-2 rounded transition-all ${
                  currentStep > step.id ? "bg-green-600" : "bg-muted"
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
